import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';
import StackedIcon from '@components/Icon/StackedIcon';

import type { StackedIconProps } from '@constants/scan';

import { useIsMobile } from '@hooks/useIsMobile';

import { FontWeight } from '../../../theme/typography';

export default function AddingButton({
  color,
  text = '',
  subText = '',
  circle = false,
  iconName,
  onClick,
  secondaryIconName,
}: {
  color?: string;
  text: string;
  subText?: string;
  circle?: boolean;
  iconName?: StackedIconProps[];
  secondaryIconName?: StackedIconProps[][];
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-arguments
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}) {
  const isMobile = useIsMobile('md');

  return (
    <Box
      p={2.75}
      m={1.25}
      onClick={(event) => onClick?.(event)}
      sx={{
        position: 'relative',
        backgroundColor: color,
        borderRadius: 2,
        height: 100,
        cursor: 'pointer',
      }}
    >
      <Stack direction="row" spacing={2}>
        {iconName && iconName.length > 0 ? (
          <StackedIcon
            icons={iconName.map((i) => ({
              size: 'xl',
              ...i,
              color: 'primary.contrastText',
            }))}
            key={`icon-${name}`}
          />
        ) : null}
        {secondaryIconName && secondaryIconName.length > 0
          ? secondaryIconName.map((icons, index) => (
              <StackedIcon
                icons={icons.map((i) => ({
                  size: 'xl',
                  ...i,
                  color: 'primary.contrastText',
                }))}
                key={`secondary-icon-${name}-${index}`}
              />
            ))
          : null}
      </Stack>
      {circle ? (
        <Box
          sx={({ palette }) => ({
            position: 'absolute',
            top: '-5px',
            right: '-5px',
            backgroundColor: palette.background.paper,
            borderRadius: '50%',
            fontSize: 17,
            height: 32,
            p: 1,
          })}
        >
          <Icon
            clickable
            color="text.primary"
            name="plus"
            type="fas"
            size="2x"
          />
        </Box>
      ) : null}

      {subText ? (
        <Typography
          color="primary.contrastText"
          variant="subtitle1"
          sx={{
            fontWeight: FontWeight.Light,
          }}
        >
          {subText}
        </Typography>
      ) : null}

      <Typography
        color="primary.contrastText"
        sx={{
          fontSize: isMobile ? 22 : 26,
          fontWeight: FontWeight.SemiBold,
          lineHeight: 1,
          position: 'absolute',
          bottom: 20,
          right: 20,
          pl: 2,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
